import { render, staticRenderFns } from "./PAccount.vue?vue&type=template&id=acf44ad2&"
import script from "./PAccount.vue?vue&type=script&lang=ts&"
export * from "./PAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports